import { render } from "./praCrdDialog.vue?vue&type=template&id=a695c25e&scoped=true"
import script from "./praCrdDialog.vue?vue&type=script&lang=js"
export * from "./praCrdDialog.vue?vue&type=script&lang=js"

import "./praCrdDialog.vue?vue&type=style&index=0&id=a695c25e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a695c25e"]])

export default __exports__